import request from '@/utils/request'


// 查询招商信息列表
export function listInvestInfo(query) {
  return request({
    url: '/invest/invest/info/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询招商信息分页
export function pageInvestInfo(query) {
  return request({
    url: '/invest/invest/info/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询招商信息详细
export function getInvestInfo(data) {
  return request({
    url: '/invest/invest/info/detail',
    method: 'get',
    params: data
  })
}

// 新增招商信息
export function addInvestInfo(data) {
  return request({
    url: '/invest/invest/info/add',
    method: 'post',
    data: data
  })
}

// 修改招商信息
export function updateInvestInfo(data) {
  return request({
    url: '/invest/invest/info/edit',
    method: 'post',
    data: data
  })
}

// 删除招商信息
export function delInvestInfo(data) {
  return request({
    url: '/invest/invest/info/delete',
    method: 'post',
    data: data
  })
}
